import { Box, CircularProgress, Skeleton, Typography, Icon } from '@mui/material'
import AdxEmptyState from 'components/reusable/emptyState/AdxEmptyState'
import BottomAddToCart from './BottomAddToCart'
import EducationCard from './EducationCard'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

const EducationDrawer = ({ data, error, isLoading }) => {
  if (isLoading) {
    return (
      <Box paddingX={2}>
        <Typography
          variant="h4"
          color="dark-text.main"
          paddingY={1}
          align="left"
          marginBottom={2}
          sx={{
            fontWeight: 'bold',
          }}
        >
          <Skeleton variant="text" width={'40%'} />
        </Typography>

        <Box display="flex" gap={9}>
          <Typography
            width={80}
            variant="body1"
            color="light-gray-text.main"
            align="left"
            marginBottom={2}
          >
            <Skeleton variant="text" />
          </Typography>
          <Typography
            display="flex"
            alignItems="center"
            variant="body1"
            color="light-gray-text.main"
            align="left"
            marginBottom={2}
          >
            <Skeleton variant="text" width={80} />
          </Typography>
        </Box>
        <Box display="flex" gap={9}>
          <Typography
            width={80}
            variant="body1"
            color="light-gray-text.main"
            align="left"
            marginBottom={2}
          >
            <Skeleton variant="text" />
          </Typography>
          <Typography
            display="flex"
            alignItems="center"
            variant="body1"
            color="light-gray-text.main"
            align="left"
            marginBottom={2}
          >
            <Skeleton variant="text" width={80} />
          </Typography>
        </Box>
        <Box display="flex" gap={9}>
          <Typography
            width={80}
            variant="body1"
            color="light-gray-text.main"
            align="left"
            marginBottom={2}
          >
            <Skeleton variant="text" />
          </Typography>
          <Typography variant="body1" color="dark-text.main" align="left" marginBottom={2}>
            <Skeleton variant="text" width={80} />
          </Typography>
        </Box>
      </Box>
    )
  } else if (error !== null || data === null || data.length <= 0) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          width: '100%',
          height: 200,
          overflow: 'hidden',
        }}
      >
        <AdxEmptyStateV2
          icon={<Icon>school</Icon>}
          title="No education record found"
          subtitle={null}
        />
      </Box>
    )
  } else {
    return (
      <Box>
        {data?.map((list) => (
          <EducationCard
            key={list}
            qualification={list.qualification_name}
            course={list.course}
            startYear={list.start_year}
            endYear={list.end_year}
            university={list.university}
            cgpa={list.cgpa}
            country={list.country}
            academicField={list.academic_field}
          />
        ))}
      </Box>
    )
  }
}
export default EducationDrawer
